import React, { useState, useRef, useEffect } from "react";
import { useApp } from "../../contexts/AppContext";
import { callGemini } from "../../services/geminiService";

const AIChat = () => {
  const { isChatOpen, setIsChatOpen, aiChatMessages, addAIMessage } = useApp();
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    scrollToBottom();
  }, [aiChatMessages]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSend = async () => {
    if (!input.trim() || isLoading) return;

    const userMessage = input.trim();
    setInput("");
    addAIMessage(userMessage, true);
    setIsLoading(true);

    const loadingId = Date.now().toString();
    addAIMessage("Escribiendo...", false, loadingId);

    const reply = await callGemini(
      userMessage,
      "Eres un tutor experto en leyes de Panamá para corredores de bienes raíces. Sé directo, amable y cita artículos cuando sea relevante."
    );

    // Reemplazar mensaje de "Escribiendo..."
    setAiChatMessages((prev) => {
      const filtered = prev.filter((msg) => msg.id !== loadingId);
      return [
        ...filtered,
        {
          id: Date.now().toString(),
          text: reply,
          isUser: false,
          timestamp: new Date(),
        },
      ];
    });

    setIsLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="fixed right-6 bottom-6 w-96 h-[500px] bg-white rounded-3xl shadow-2xl border border-slate-200 z-[100] flex flex-col transform transition-all animate-fade">
      {/* Header */}
      <div className="p-4 bg-indigo-600 text-white rounded-t-3xl flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
            ✨
          </div>
          <span className="font-bold">Tutor Inteligente PanamaBR</span>
        </div>
        <button
          onClick={() => setIsChatOpen(false)}
          className="p-1 hover:bg-white/10 rounded-lg transition-colors"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      {/* Messages */}
      <div className="flex-grow overflow-y-auto p-4 space-y-4 custom-scrollbar bg-slate-50">
        {aiChatMessages.map((message) => (
          <div
            key={message.id}
            className={`flex ${
              message.isUser ? "justify-end" : "justify-start"
            }`}
          >
            <div
              className={`max-w-[80%] p-3 rounded-2xl text-xs ${
                message.isUser
                  ? "bg-blue-600 text-white rounded-tr-none"
                  : "bg-indigo-50 text-indigo-800 border border-indigo-100 rounded-tl-none"
              } ${message.text === "Escribiendo..." ? "italic" : ""}`}
            >
              {message.text}
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      {/* Input */}
      <div className="p-4 border-t bg-white rounded-b-3xl">
        <div className="flex gap-2">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Escribe tu duda legal..."
            disabled={isLoading}
            className="flex-grow px-4 py-2 bg-slate-100 rounded-xl text-sm outline-none focus:ring-2 focus:ring-indigo-500 transition-all disabled:opacity-50"
          />
          <button
            onClick={handleSend}
            disabled={isLoading || !input.trim()}
            className="bg-indigo-600 text-white p-2 rounded-xl hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIChat;
